import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import "../assets/styles/header.scss";
import '../assets/styles/dailySummarizer.scss';
import "../assets/styles/generator.scss"
import Login from "../pages/Login";
import PrivateRoute from "./PrivateRoute";
import OAuthHandler from './OAuthHandler';
import MainLayout from "../layout/MainLayout";
import OpenChat from "../pages/OpenChat";
import PCVC from "../pages/pcvc/PCVC";
import ComplaintAnalyser from "../pages/rca-cis/rca";
import EarlyClaims from "../pages/early-claims/EarlyClaims";
import ErrorPage from "../pages/Error-page/ErrorPage";
import ReportGenerator from "../pages/reportgenerator/Reportgenerator";
import ReportAnalyser from "../pages/report-analyser/ReportAnalyser";
import CallRepository from "../pages/CallRepository/CallRepository";
import ErrorBoundary from "../components/ErrorBoundary";
import DefaultRoute from "./DefaultRoute";
import SummarySheet from "../pages/summary-sheet/SummarySheet"
import CancellationGrid from "../pages/cancellation-grid/CancellationGrid";
import ComplianceGpt from "../pages/compliance-gpt/ComplianceGpt"
import GptTemplate from "../pages/gpt-template/GptTemplate"
import UwFraud  from "../pages/uw-fraud/UW-fraud"
import { Auth } from "../libs/utilities/helpers/Auth";

const AppRouter = () => {

    const user = Auth.getUser();  
    // render all the dynamic gpt routes based on the type gpt
    const gptRoutes = user?.accessibility
        ?.filter(service => service.type === "gpt")
        ?.map(service => {
            return {
                path: service.service,
                element: (
                    <ErrorBoundary key={service.service}>
                        <GptTemplate
                            serviceName={service.service}
                            feature={service.feature}
                            title={service.title}
                            serviceId={service._id}
                        />
                    </ErrorBoundary>
                )
            };
        }) || [];


    const routes = useRoutes([
        {
            path: "/error",
            element: <ErrorPage />,
        },
        {
            path: "/login",
            element: <Login />,
        },{
            path: "/",
            element: <OAuthHandler />,
        }, {
            path: "*",
            element: <Navigate to="/" />
        },
        {
            path: "/",
            element: <PrivateRoute element={<MainLayout />} />,
            children: [
                {
                    path: "",
                    element: <DefaultRoute />
                },
                {
                    path: "chat-ai",
                    element: <ErrorBoundary key="1"><OpenChat /></ErrorBoundary>,
                },
                {
                    path: "report-analyser",
                    element: <ErrorBoundary key="2"><ReportAnalyser /></ErrorBoundary>,
                },
                {
                    path: "report-generator",
                    element: <ErrorBoundary key="3"><ReportGenerator /></ErrorBoundary>,
                },
                {
                    path: "complaint-analyser",
                    element: <ErrorBoundary key="4"><ComplaintAnalyser /></ErrorBoundary>,
                },
                {
                    path: "pcvc",
                    element: <ErrorBoundary key="8"><PCVC /></ErrorBoundary>,
                },
                {
                    path: "pre-claims",
                    element: <ErrorBoundary key="9"><EarlyClaims /></ErrorBoundary>
                },
                {
                    path: "call-repository",
                    element: <ErrorBoundary key="10"><CallRepository /></ErrorBoundary>
                },
                {
                    path: "summary-sheet",
                    element: <ErrorBoundary key="11"><SummarySheet /></ErrorBoundary>
                },
                {
                    path: "cancellation-grid",
                    element: <ErrorBoundary key="12"><CancellationGrid /></ErrorBoundary>
                },
                {
                    path: "compliance-gpt",
                    element: <ErrorBoundary key="13"><ComplianceGpt /></ErrorBoundary>
                },
                {
                    path: "financial-fraud",
                    element: <ErrorBoundary key="20"><UwFraud feature={{"title":"Financial Risk Intelligence","type":"financial","id":""}} /></ErrorBoundary>
                },
                ...gptRoutes,
            ]
        }
    ]);
    return routes;
};

export default AppRouter;
